<template>
  <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="show">
    <template v-slot:activator="{on}">
      <v-btn v-on="on" fab fixed bottom left color="grey darken-2">
        <v-icon>mdi-account</v-icon>
      </v-btn>
    </template>
    <v-card class="text-center">
      <v-btn fab fixed top right @click="show = false" color="error">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <div class="display-1">Account</div>
      <v-container>
        <v-row>
          <v-col cols="12" class="title">
            Logged in as:
          </v-col>
          <v-col cols="12" class="pa-0 ma-0">
            {{ email }}
          </v-col>
          <v-col cols="12">
            <v-btn @click="signOut" class="ma-3" color="pink">Logout</v-btn>
          </v-col>
        </v-row>
        <v-divider/>
        <h2 class="grey--text mt-2">Account Link</h2>
        <v-row justify="center" v-if="hasLink">
          <v-col cols="12">
            <v-row>
              <v-col cols="12" class="grey--text ma-0 pa-0">
                Account Linked {{ linkedTo ? 'To:' : 'With:' }}
              </v-col>
              <v-col cols="12" class="ma-0 pa-0">
                {{ linkedTo ? linkedTo : linkedWith }}
              </v-col>
              <template v-if="linkedTo">
                <v-col cols="6" class="text-right grey--text">
                  Verified:
                </v-col>
                <v-col cols="6" class="text-left">
                  {{ linkedVerified ? 'Yes' : 'No' }}
                  <v-icon dark class="ml-1" :color="linkedVerified ? 'teal' : 'pink'">
                    {{ linkedVerified ? 'mdi-check-decagram' : 'mdi-alert-circle' }}
                  </v-icon>
                </v-col>
                <v-col cols="12" class="subtitle-2 grey--text">
                  <template v-if="linkedVerified">
                    You can read and write feeds on behalf of {{ linkedTo }}.
                  </template>
                  <template v-else>
                    You have requested to read and write feeds on behalf of {{ linkedTo }}.
                  </template>
                </v-col>
              </template>
              <template v-else>
                <v-col cols="12" class="subtitle-2 grey--text">
                  They can read and write your feeds.
                </v-col>
              </template>
              <v-col>
                <v-btn color="teal" @click="removeLink">Remove Link</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row justify="center" v-else>
          <v-col cols="8">
            <v-row>
              <v-col cols="12">
                <v-btn @click="linkTo = !linkTo">Link {{ linkTo ? 'To' : 'With' }}</v-btn>
              </v-col>
              <v-col cols="12">
                <div v-if="linkTo">
                  Read and Write feeds from another account.
                </div>
                <div v-else>
                  Allow another account to read and write your feeds.
                </div>
              </v-col>
              <v-col>
                <v-text-field v-if="linkTo" label="Link To" v-model="link"/>
                <v-text-field v-else label="Link With" v-model="link"/>
                <v-btn color="teal" @click="saveLink">Save</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {auth} from '../firebase';

export default {
  name: 'AccountInfo',
  data() {
    return {
      linkTo: false,
      link: '',
      show: false
    };
  },
  computed: {
    ...mapGetters('auth', [
      'email'
    ]),
    ...mapGetters('user', [
      'linkedWith',
      'linkedTo',
      'linkedVerified',
      'hasLink'
    ])
  },
  methods: {
    ...mapActions('user', [
      'clearLink',
      'getLinkedUserDoc',
      'updateUserDoc'
    ]),
    saveLink() {
      if (!this.link || this.link === '') {
        return;
      }
      const data = {};
      if (this.linkTo) {
        data.linkTo = this.link;
      } else {
        data.linkWith = this.link;
      }
      this.updateUserDoc(data)
          .then(() => {
            if (this.linkTo) {
              return this.getLinkedUserDoc();
            }
          })
          .catch(error => {
            this.$logger.error(error);
          });
    },
    signOut() {
      auth.signOut().catch(error => {
        this.error = error;
        this.$logger.error(error);
      });
    },
    removeLink() {
      this.clearLink().catch(error => {
        this.$logger.error(error);
      });
    }
  }
}
</script>

<style scoped>
  .display-1 {
    padding-top: 25px;
  }
</style>
